var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5474 4.00019C13.4332 4.00363 13.3248 4.05186 13.2452 4.13467L9.88407 7.53122L6.52292 10.9278L3.75673 8.13244C3.71622 8.08981 3.66771 8.05578 3.61402 8.03233C3.56034 8.00888 3.50257 7.9965 3.44409 7.9959C3.3856 7.99529 3.32759 8.00649 3.27345 8.02883C3.2193 8.05117 3.17011 8.0842 3.12876 8.12599C3.08741 8.16778 3.05472 8.21748 3.03261 8.2722C3.01051 8.32692 2.99943 8.38554 3.00002 8.44463C3.00062 8.50373 3.01288 8.56211 3.03608 8.61636C3.05928 8.67061 3.09296 8.71964 3.13515 8.76057L6.21213 11.8699C6.29457 11.9532 6.40636 12 6.52292 12C6.63948 12 6.75127 11.9532 6.83371 11.8699L13.8668 4.76279C13.9303 4.7004 13.9737 4.62007 13.9913 4.53233C14.0088 4.44459 13.9998 4.35354 13.9652 4.2711C13.9307 4.18867 13.8723 4.11869 13.7978 4.07035C13.7232 4.02201 13.636 3.99755 13.5474 4.00019Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b6634309.svg";
export { ForwardRef as ReactComponent };